const tabDefaultStyle = (theme, currentIndex) => {
  const style = {
    backgroundColor: theme.tokens.ComponentTabsBg,
    textTransform: 'none',
    padding: '14px 8px',
    color: theme.tokens.ComponentTabsUnSelectedColor,
    minHeight: '48px',
    '&.MuiTab-labelIcon': {
      padding: '10px 8px'
    },
    '&.Mui-selected': {
      color: theme.tokens.ComponentTabsSelectedColor
    },
    '&.Mui-disabled': {
      color: theme.tokens.ComponentTabsDisabledColor
    },
    '&:hover, &:focus': {
      backgroundColor: currentIndex ? 'none' : theme.tokens.ComponentTabsHoverColor
    },
    '&:focus-visible': {
      borderStyle: 'solid',
      borderColor: theme.tokens.ComponentTabsFocusBorder,
      borderWidth: '1px'
    },
    fontSize: '16px',
    fontFamily: theme.tokens.SemTypeFontBody
  };
  return style;
};
export default tabDefaultStyle;